import * as Styles from './styles';
import { formatDateTime } from 'utils/date';

interface IProps {
    modelName: string;
    imei: string;
    activationDate: string;
    showActivationDate: boolean;
}

const ModelDetails: React.FC<IProps> = (props) => {
    const { modelName, activationDate, imei, showActivationDate } = props;
    return (
        <Styles.Wrapper>
            <Styles.Text>
                <span style={{ fontWeight: 600 }}>Model Name:</span> {modelName}
            </Styles.Text>
            <Styles.Text>
                <span style={{ fontWeight: 600 }}>IMEI:</span> {imei}
            </Styles.Text>
            {showActivationDate && activationDate && (
                <Styles.Text>
                    <span style={{ fontWeight: 600 }}>Activation Date:</span>{' '}
                    {formatDateTime(activationDate)}
                </Styles.Text>
            )}
        </Styles.Wrapper>
    );
};

export default ModelDetails;
